import React, { Component } from "react";
import plus from "../images/plus.svg";
import minus from "../images/minus.svg";
// import CustomButton from './CustomButton'
// import NumberFormat from "react-number-format";
import { NumericFormat } from "react-number-format";

export default class EditableOrderItem extends Component {
  plusClick() {
    this.props.onOrderChange(this.props.foodId, "plus");
  }

  minusClick() {
    this.props.onOrderChange(this.props.foodId, "minus");
  }

  render() {
    return (
      <div className="editableOrderItem">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className="orderItemImgContainer">
            <img src={this.props.img} alt="" className="orderItemImg" />
          </div>
          <div className="orderItemDesContainer">
            <div className="orderItemTimeContainer">
              <div className="orderItemTitle" style={{ padding: "0" }}>
                {this.props.title}
              </div>

              <div
                className="orderItemPrice"
                style={{ flexDirection: "row", padding: "0" }}
              >
                <NumericFormat
                  allowNegative={true}
                  value={this.props.price}
                  displayType={"text"}
                  thousandSeparator={true}
                />
                <div>&nbsp;{this.props.unit}</div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "1px",
                backgroundColor: "var(--gray4)",
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
                alignItems: "center",
                paddingTop: "6px",
              }}
            >
              <div
                className="orderItemDes"
                style={{ flex: "1", marginRight: "10px", padding: "0" }}
              >
                {this.props.des}
              </div>
              {!this.props.viewMode && (
                <div className="editableOrderItemActionsContainer">
                  <div
                    className="plusminus"
                    onClick={this.minusClick.bind(this)}
                  >
                    <img
                      src={minus}
                      style={{
                        width: "55%",
                        height: "2px",
                        objectFit: "contain",
                      }}
                      alt=""
                    />
                  </div>
                  <div style={{ width: "2px" }} />
                  <div
                    style={{ minWidth: "25px", maxWidth: "25px" }}
                    className="orderItemCount"
                  >
                    {this.props.quantity}
                  </div>
                  <div style={{ width: "2px" }} />
                  <div
                    className="plusminus"
                    onClick={this.plusClick.bind(this)}
                  >
                    <img
                      src={plus}
                      style={{
                        width: "55%",
                        height: "55%",
                        objectFit: "contain",
                      }}
                      alt=""
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* <div className="orderItemSpliter" /> */}
        </div>
      </div>
    );
  }
}
